import { tasks_table_header_cells } from "../../assets/data"
import TasksHeaderCell from "./TasksHeaderCell"


export default function TasksHeader({isInTab}) {
    

    return <thead>
        <tr>
            {/* .filter(item => isInTab ? item.id !=1 : item) */}
            {tasks_table_header_cells && tasks_table_header_cells.map(item => (
                <th key={item.id} >
                    <TasksHeaderCell item={item}/>
                </th>
            ))}
        </tr>
    </thead>
}